import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Exercice } from '../../model/exercice.model';
import { ExerciceService } from '../../service/exercice.service';
import { ExerciceSheetService } from '../../service/exerciceSheet.service';
import { Language } from '../../model/language.model';
import { Teacher } from '../../model/teacher.model';
import { AuthenticationService } from '../../service/authentification.service';
import { ExerciceMediaService } from '../../service/exerciceMedia.service';
import { HttpParams } from '@angular/common/http';
import { ExerciceCategoryService } from '../../service/exerciceCategory.service';

@Component({
  selector: 'app-create-exercice-offsite',
  templateUrl: './create-exercice.component.html',
  styleUrls: ['./create-exercice.component.scss',]
})
export class CreateExerciceComponent implements OnInit {
  @Input() language: Language;
  @Output() exerciceCreated = new EventEmitter<Exercice>();
  difficultyList = [];
  teacher: Teacher = null;
  categoryList = [];
  files: any = null;

  exerciceFormGroup = new FormGroup({
    title: new FormControl('', Validators.required),
    difficulty: new FormControl('', Validators.required),
    duration: new FormControl<number>(null, Validators.required),
    instructions: new FormControl('', Validators.required),
    category: new FormControl(''),
  });

  constructor(
    private exerciceService: ExerciceService,
    private authenticationService: AuthenticationService,
    private exerciceMediaService: ExerciceMediaService,
    private exerciceCategoryService: ExerciceCategoryService
  ) { }

  ngOnInit() {
    this.teacher = this.authenticationService.currentUserSubject.value;
    this.difficultyList = this.exerciceService.getDifficultyList();

    const _params = new HttpParams().set('status', 'active');
    this.exerciceCategoryService.getCategories(_params).subscribe(data => {
      if (data['results']) {
        this.categoryList = data['results'];
      }
    });
  }

  createExercice() {
    const forms = this.exerciceFormGroup.controls;
    const _params = {
      difficulty: forms.difficulty.value,
      duration: forms.duration.value,
      status: 'published',
      type_exercice: 'offsite',
      language: this.language,
      instruction_student: forms.instructions.value,
      title: forms.title.value,
      lilate_criteria: [],
      teacher: this.teacher.url,
      category: forms.category.value
    };

    this.exerciceService.postExercice(_params).subscribe(exerciceCreated => {
      if (exerciceCreated.id) {
        this.exerciceCreated.emit(exerciceCreated);
        if (this.files) {
          this.uploadFile(exerciceCreated.id);
        }
      }
    });
  }

  storeFiles($event) {
    this.files = $event.target.files;
  }

  uploadFile(id) {
    for (const file of this.files) {
      const _params = {
        media_type: 'binary',
        source_type: 'stored',
        content_type: 'exercice',
        object_id: id,
      };
      this.exerciceMediaService.postStoredMedia(file, _params)
        .then(() => {
        });
    }
  }
}
